import axios from '../request/http';

const merchant = {
    // 商户管理列表
    businessList(params) {
        return axios.get("/proxy/admin/business/info/list", {params});
    },
    // 商户详情信息
    businessDetail(params) {
        return axios.get("/proxy/admin/business/info/detail", {params});
    },
    // 商品管理列表
    listAll(params) {
        return axios.get("/proxy/admin/category/listAll", {params});
    },
    // 城市列表
    cityList(params) {
        return axios.get("/proxy/admin/business/city/list", {params});
    },
    // 商户信息编辑
    businessEdit(data) {
        return axios.post("/proxy/admin/business/info/edit", data);
    },

    // 商户服务产品列表
    serveList(params) {
        return axios.get("/proxy/admin/business/service/list", {params});
    },
    // 服务产品上下架
    serveDown(params) {
        return axios.get("/proxy/admin/business/down", {params});
    },
    // 商户服务产品新增/编辑服务
    serveListAdd(data) {
        return axios.post("/proxy/admin/business/service/edit", data);
    },
    // 服务产品删除
    serveDel(params) {
        return axios.get("/proxy/admin/business/service/delete", {params});
    },
    // 服务产品详情
    serveDetail(params) {
        return axios.get("/proxy/admin/business/service/detail", {params});
    },
    // 商户禁用启用、审核、推荐
    businessStatus(params) {
        return axios.get("/proxy/admin/business/status/update", {params});
    },
}

export default merchant;


// WEBPACK FOOTER //
// ./src/api/merchant.js